export const environments = [
  {
    id: "second-wave",
    name: "Second Wave",
    path: "assets/environment/second_wave2k.hdr",
    format: ".hdr",
    background: "19191a",
  },
  {
    id: "first-wave",
    name: "First Wave",
    path: "assets/environment/first_wave2k.hdr",
    format: ".hdr",
    background: "19191b",
  },
  {
    id: "first-nebula",
    name: "First Nebula",
    path: "assets/environment/first_nebula2k.hdr",
    format: ".hdr",
    background: "19191c",
  },
  {
    id: "second-nebula",
    name: "Second Nebula",
    path: "assets/environment/second_nebula2k.hdr",
    format: ".hdr",
    background: "19191c",
  },
  {
    id: "third-wave",
    name: "Third Wave",
    path: "assets/environment/third_wave2k.hdr",
    format: ".hdr",
  },
  {
    id: "lost-in-space",
    name: "Lost in Space",
    path: "assets/environment/lost_in_space2k.hdr",
    format: ".hdr",
  },
  {
    id: "none",
    name: "None",
    path: null,
    format: ".hdr",
  },
];
